import InfoList from "components/InfoList/InfoList";


const Information = () => {
  return (
    <InfoList
      page={null}
      variant="mainInfo"
      sliceName="information"
      listOf="information"
      itemProps={{ variant: "mainInfoCard", button: true, }}
      count={4}
    />
  );
};

export default Information;
